import OTPForm, { OTP_VIEWS } from './otp-form';
export default OTPForm;
export { OTP_VIEWS };
